package one.healthium.update_food_preferences.di

import one.healthium.channels.di.channelsModule
import one.healthium.update_food_preferences.data.AppFoodPreferencesRepository
import one.healthium.update_food_preferences.data.mapper.FoodPreferencesMapper
import one.healthium.update_food_preferences.domain.FoodPreferenceInteractor
import one.healthium.update_food_preferences.domain.FoodPreferencesRepository
import one.healthium.update_food_preferences.ui.UpdateFoodPreferencesViewModel
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val updateFoodPreferencesModule = module {
    includes(channelsModule)

    singleOf(::FoodPreferencesMapper)

    singleOf(::AppFoodPreferencesRepository) bind FoodPreferencesRepository::class

    factoryOf(::FoodPreferenceInteractor)

    viewModelOf(::UpdateFoodPreferencesViewModel)
}